import React from 'react'
import FormSection from 'components/FormSection'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import Grid from '@material-ui/core/Grid'
import SelectField from 'components/SelectField'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import AutoSuggestionInput from 'components/AutoSuggestionInput'
import { languages } from 'suggestions'
import InputLabel from '@material-ui/core/InputLabel';

const Languages = ({
  mutators
}) => (
  <FormSection
    title={(
        <Typography variant="h6" component="h2">
          Języki obce
        </Typography>
    )}
  >
    <MultiFieldsGroup
      name='languages'
      mutators={mutators}
      label='język'
      fieldToPreview='type'
      renderFieldsGroup={(name, index) => (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
              Język
            </InputLabel>
            <AutoSuggestionInput
              name={`${name}.type`}
              type="text"
              suggestions={languages}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
              Poziom
            </InputLabel>
            <SelectField
              name={`${name}.level`}
              options={[
                {
                  value: "1",
                  label: "*"
                },
                {
                  value: "2",
                  label: "**"
                },
                {
                  value: "3",
                  label: "***"
                },
                {
                  value: "4",
                  label: "****"
                },
                {
                  value: "5",
                  label: "*****"
                },
                {
                  value: "C2",
                  label: "C2"
                },
                {
                  value: "C1",
                  label: "C1"
                },
                {
                  value: "B2",
                  label: "B2"
                },
                {
                  value: "B1",
                  label: "B1"
                },
                {
                  value: "A2",
                  label: "A2"
                },
                {
                  value: "A1",
                  label: "A1"
                }
              ]}
            />
          </Grid>
        </Grid>
      )}
    />
  </FormSection>
)

export default Languages